import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
 import { Reason } from 'src/app/shared/enums/enums';
import { UserApiService } from '../../user-api.service';

@Component({
  selector: 'app-password-history',
  templateUrl: './password-history.component.html',
  styleUrls: ['./password-history.component.css']
})
export class PasswordHistoryComponent implements OnInit {
  Ereason = Reason
  listOfReasron: any[] = [];
  displayedColumns: string[] = ['number', 'reason', 'date']
  dataSource: any;
  userId = 0
  constructor(
    private dialogRef: MatDialogRef<PasswordHistoryComponent>,
    private userService: UserApiService,
    @Inject(MAT_DIALOG_DATA) data

  ) {
    this.userId = data.userId
  }

  ngOnInit() {
    if (this.userId) {
      this.getUserHistory()
    }
  }
  getUserHistory() {
    this.userService.getchangeHistory(this.userId).subscribe((res) => {
      this.dataSource = res
    })
  }
  close() {
    this.dialogRef.close();
  }
  ReasoneOfPassword(data) {
    for (const key in Reason) {
      if (data == Reason[key]) {
        return data = key.replace("_"," ")
      }
    }
  }
}
